import { errorMessage } from '~/constants'
import { isValidArray } from './object'
import { ERROR_VOUCHER } from '~/constants/voucher'

// Xử lý gửi data phù hợp phía BE
export const transformToppings = (foodOptionTypes = []) => {
  return foodOptionTypes.reduce((total, foodOptionType) => {
    const { id, foodOptions } = foodOptionType
    const foodOptionsUpdated = foodOptions.map((item) => {
      return {
        quantity: item?.quantity || 1,
        price: item?.price || 0,
        food_option_id: item.id,
        food_item_option_id: item.food_item_option_id,
        linkage_food_option_id: item?.linkage_food_option_id, // Trong trường hợp Sukiya sẽ gửi cái này lên
        food_option_type_id: id,
      }
    })

    return total.concat(foodOptionsUpdated)
  }, [])
}

/* Tính tổng tiền food option = số lượng * đơn giá */
export const totalFoodOptions = (food_options) => {
  if (!Array.isArray(food_options)) return 0

  return food_options.reduce((total, item) => {
    const { price, quantity } = item
    return total + (quantity || 1) * (price || 0)
  }, 0)
}

/* Tính tổng tiền topping type = tổng tiền của từng food option */
export const totalFoodOptionTypes = (food_option_types) => {
  if (!Array.isArray(food_option_types)) return 0

  return food_option_types.reduce((total, item) => {
    const foodOptionObject = item?.foodOptions || item?.food_options
    return total + totalFoodOptions(foodOptionObject)
  }, 0)
}

/* Tính tổng tiền chi tiết món ăn = (giá gốc + tổng tiền topping type) * số lượng */
export const getTotalPriceIncludeTopping = (foodItem) => {
  const { price, quantity } = foodItem
  const toppingTypeObject = foodItem?.foodOptionTypes || foodItem?.food_option_types
  return (price + totalFoodOptionTypes(toppingTypeObject)) * (quantity || 1)
}

/** func format data request trước khi đẩy lên
 * @param {array} cartData
 */
export const formattedCartData = (cartData, food_court_id) => {
  if (cartData?.length <= 0) return null
  const newData = cartData.map((foodItem) => {
    const { id, quantity, price, note, foodOptionTypes, restaurant_id, is_buffet_item } = foodItem
    const newItem = {
      kind: is_buffet_item ? 'buffet_item_order' : 'food_order',
      food_item_id: id,
      quantity,
      price,
      note,
    }

    // Trong trường hợp là food court -> gửi thêm restaurant_id
    if (food_court_id) {
      newItem.restaurant_id = restaurant_id
    }

    // nếu có topping
    if (isValidArray(foodOptionTypes)) {
      newItem.requests_food_options_attributes = transformToppings(foodOptionTypes)
    }
    return newItem
  })

  // if (noteOrder) {
  //   const newNote = {
  //     kind: 'order_note',
  //     note: noteOrder,
  //   }
  //   newData.push(newNote)
  // }

  return newData
}

/** func parse lỗi bên server trả về để hiển thị */
export const getMessageOrderError = (err) => {
  if (!err) return ''
  try {
    const { status } = err.response
    const { data } = err.response || {}
    const { message: messageFromServer } = data || ''
    if (status === 422) {
      return convertErrorCodeToString(messageFromServer)
    }
  } catch (e) {
    return ''
  }
}

/** convert error code to string */
export const convertErrorCodeToString = (mess) => {
  if (!mess) return ''
  switch (mess) {
    case errorMessage.OUT_OF_STOCK:
    case errorMessage.ORDER_ITEM_NOT_ENOUGH:
      return 'errors.errorOutOfStock'
    case errorMessage.FOOD_ITEM_QUANTITY_EXCEEDED:
      return 'errors.errorQuantityExceeded'
    case errorMessage.FOOD_ITEM_PRICE_CHANGED:
    case errorMessage.INVALID_CATEGORY:
    case errorMessage.INVALID_FOOD_ITEM:
    case errorMessage.TOPPING_HAS_CHANGED:
      return 'errors.errorFoodHasChanged'
    case errorMessage.PAYMENT_METHOD_HAS_CHANGE:
      return errorMessage.PAYMENT_METHOD_HAS_CHANGE // để như này do muốn hiển thị 2 text payment method, ko phải 1 text như các error khác
    case errorMessage.TABLE_NOT_OPEN:
      return 'errors.errorNotOpenTable'
    case 'VOUCHER_OUT_OF_STOCK':
      return ERROR_VOUCHER.VOUCHER_OUT_OF_STOCK

    default:
      return 'errors.somethingWrong'
  }
}
